<template>
  <div class="column">
    <div class="row justify-end">
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList('candidat')">{{$t('processes.export_candidat')}}</q-btn>
      </div>
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList()">{{$t('processes.export')}}</q-btn>
      </div>
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" :to="{ name: 'suivi-de-recrutement-form' }" icon-right="add_circle">{{$t('processes.create_suivi_de_recrutement')}}</q-btn>
      </div>
    </div>
    <q-table flat wrap-cells
      :data="recrutementProcesses"
      :columns="columns"
      row-key="id"
      :rows-per-page-options="rowsPerPageOptions"
      :pagination.sync="pagination"
      :loading="loading"
      :filter="filter"
      @request="onRequest"
      binary-state-sort>
      <template v-slot:body-cell-wallets="props">
        <q-td :props="props" @click.native="$router.push({ name: 'suivi-de-recrutement-form', params: { id: props.row.id } })" class="cursor-pointer">
          {{props.value}}
        </q-td>
      </template>
      <template v-slot:body-cell-candidats="props">
        <q-td :props="props">
            <router-link v-for="(candidat, index) in props.value" :key="candidat.id" :to="{ name: 'candidat-fiche', params: { id: candidat.id, processId: props.row.id } }">
              {{index === props.value.length - 1 ? candidat.nom : `${candidat.nom} - ` }}
            </router-link>
        </q-td>
      </template>
    </q-table>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import download from 'downloadjs'

export default {
  name: 'SuiviDeRecrutementList',

  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext }) {
    store.dispatch('processes/fetchFilters', 'recrutement')
  },

  meta () {
    return {
      title: 'Suivi de recrutement'
    }
  },

  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters({
      recrutementProcesses: 'processes/getProcesses',
      filters: 'processes/getFilters',
      rowsPerPageOptions: 'config/getRowsPerPageOptions'
    }),
    pagination: {
      ...mapGetters({ get: 'processes/getPagination' }),
      ...mapMutations({ set: 'processes/setPagination' })
    },
    filter () {
      return this.$route.meta.filter
    },

    columns () {
      console.log(this.recrutementProcesses, this.filters)
      if (this.recrutementProcesses.length === 0) return []
      else {
        const fields = ['wallets', 'candidats', 'date_cible', 'statut']
        const sortable = ['date_cible', 'statut']

        return fields.map(key => {
          let label = this.$t(`processes.fields.${key}.label`)
          let align = 'left'
          let autoWidth = false
          let formatFn = val => val

          if (key === 'wallets') {
            label = 'Portefeuille(s)'
            formatFn = val => {
              return val.map(wallet => wallet.NOMPTF).join(', ')
            }
          } if (key === 'candidats') {
            label = 'Liste des candidats'
            formatFn = val => val.map(candidat => ({
              nom: candidat.nom,
              id: candidat.id
            }))
          } else if (key === 'date_cible') {
            formatFn = val => this.$formatDate(val)
          } else if (key === 'statut') {
            formatFn = val => {
              if (val) return this.$t(`processes.status.${val}`)
              return ''
            }
            align = 'center'
          }

          return {
            name: key,
            align: align,
            label: label,
            field: key,
            format: formatFn,
            sortable: sortable.indexOf(key) >= 0,
            autoWidth: autoWidth
          }
        })
      }
    }
  },

  watch: {
    filters: {
      handler (newVal, oldVal) {
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    },
    '$route.meta.filter': {
      handler (newVal, oldVal) {
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    }
  },

  mounted () {
    if (this.filters) {
      this.onRequest({ pagination: this.pagination })
    }
    this.$store.commit('pages/setBreadcrumbs', [
      { label: this.$t('global.home'), to: { name: 'home' }, icon: 'home' },
      { label: this.$t('processes.processAgence'), to: { name: '' } },
      { label: this.$t('processes.title.suivi_de_recrutement'), to: { name: 'suivi-de-recrutement-en-cours' } },
      {}
    ])

    this.$store.commit('pages/setPageTitle', this.$t('processes.title.suivi_de_recrutement'))
    this.$store.commit('pages/setTabs', [
      { name: 'suivi-de-recrutement-en-cours', label: 'En cours', to: { name: 'suivi-de-recrutement-en-cours' } },
      { name: 'suivi-de-recrutement-archivés', label: 'Archivés', to: { name: 'suivi-de-recrutement-archives' } }
    ])
  },

  methods: {
    onRequest ({ pagination, filter }) {
      this.$store.commit('processes/setPagination', pagination)
      this.loading = true

      let params = { ...pagination, filter: this.filter, typeProcess: 'recrutement' }
      if (this.filters) this.filters.forEach(filter => { params[filter.id] = filter.value })

      this.$store.dispatch('processes/fetchProcesses', params)
        .finally(() => { this.loading = false })
    },

    exportList (process) {
      let toExport = process || 'recrutement'
      this.$axios.get(`/api/processAgences/${toExport}/export`, {
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'text/csv' }
      }).then(response => {
        download(response.data, `${toExport}.csv`)
      }).catch(this.$notifyError)
    }
  }
}
</script>
